import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import RoleRoute from './RoleRoute';
import DashboardPage from '../Pages/Dashboard/Dashboard';
import LoginPage from '../Pages/LoginPage/LoginPage';
import SalesAnalytics from '../Pages/Views/SalesAnalytics/SalesAnalytics';
import Transcations from '../Pages/Views/Transcations/Transcations';
import Billings from '../Pages/Views/Billings/Billings';
import VendingMachines from '../Pages/Manage/VendingMachines/VendingMachines';
import Inventory from '../Pages/Manage/Inventory/Inventory';
import Advertisements from '../Pages/Manage/Advertisements/Advertisements';
import MembershipCards from '../Pages/Manage/MembershipCards/MembershipCards';
import Discounts from '../Pages/Manage/Discounts/Discounts';
import Coupons from '../Pages/Manage/Coupons/Coupons';
import Returns from "../Pages/Manage/Returns/Returns";
import Users from '../Pages/Manage/Users/Users';
import ServiceRequest from '../Pages/Maintenance/ServiceRequest/ServiceRequest';
import Taxes from '../Pages/Taxes/Taxes';
import Spares from '../Pages/Maintenance/Spares/Spares';
import Help from '../Pages/Help/Help';
import VendingMachineModal from '../Pages/Manage/VendingMachines/VendingMachineModal';
import MachineDetails from '../Pages/Manage/VendingMachines/MachineDetails';
import AdvertisementModal from '../Pages/Manage/Advertisements/AdvertisementModal';
import TaxReport from '../Pages/Taxes/TaxReport';
import Franchise from '../Pages/Franchise/Franchise';
import FranchiseModal from '../Pages/Franchise/FranchiseModal';
// import Payout from "../Pages/Franchise/Payout";
import Documentation from '../Pages/Help/documentation/documentation.js';
import Faq from '../Pages/Help/FAQs/faq.js';
import TrustSafety from '../Pages/Help/Imprints/trustsafety.js';
import Terms from '../Pages/LoginPage/terms.js';
import Complaints from '../Pages/Maintenance/ServiceRequest/Complaints/Complaints.js';
import CartPage from '../Pages/Maintenance/Spares/CartPage.js';
import Orders from '../Pages/Maintenance/Spares/orderPage.js';
import OrdersDetails from '../Pages/Maintenance/Spares/orderDetails.js';
import Academy from '../Pages/Academy/Academy.js';

const AppRouter = () => {
    return (
        <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/privacy" element={<Terms />} />
            <Route path="/" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />

            {/* Protected routes */}
            <Route path="/dashboard" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
            <Route path="/sales-analytics" element={<RoleRoute allowedRoles={['ROLE_ADMIN']}><SalesAnalytics /></RoleRoute>} />
            <Route path="/transactions" element={<RoleRoute allowedRoles={['ROLE_ADMIN']}><Transcations /></RoleRoute>} />
            <Route path="/billings" element={<RoleRoute allowedRoles={['ROLE_ADMIN']}><Billings /></RoleRoute>} />
            <Route path="/vending-machines" element={<PrivateRoute><VendingMachines /></PrivateRoute>} />
            <Route path="/add-machine" element={<RoleRoute allowedRoles={['ROLE_SUPER_ADMIN']}><VendingMachineModal /></RoleRoute>} />
            <Route path="/machine-details/:id" element={<PrivateRoute><MachineDetails /></PrivateRoute>} />
            <Route path="/inventory" element={<PrivateRoute><Inventory /></PrivateRoute>} />
            <Route path="/advertisements" element={<PrivateRoute><Advertisements /></PrivateRoute>} />
            <Route path="/add-advertisement" element={<PrivateRoute><AdvertisementModal /></PrivateRoute>} />
            <Route path="/customers" element={<PrivateRoute><MembershipCards /></PrivateRoute>} />
            <Route path="/discounts" element={<PrivateRoute><Discounts /></PrivateRoute>} />
            <Route path="/coupons" element={<PrivateRoute><Coupons /></PrivateRoute>} />
            <Route path="/returns" element={<PrivateRoute><Returns /></PrivateRoute> } />
            <Route path="/users" element={<RoleRoute allowedRoles={['ROLE_ADMIN']}><Users /></RoleRoute>} />
            <Route path="/taxes" element={<RoleRoute allowedRoles={['ROLE_ADMIN']}><Taxes /></RoleRoute>} />
            <Route path="/taxReport" element={<RoleRoute allowedRoles={['ROLE_ADMIN']}><TaxReport /></RoleRoute>} />
            <Route path="/service-request" element={<PrivateRoute><ServiceRequest /></PrivateRoute>} />
            <Route path="/complaints" element={<PrivateRoute allowedRoles={['ROLE_SUPER_ADMIN']}><Complaints /></PrivateRoute>} />
            {/* <Route path="/spares" element={<PrivateRoute><Spares /></PrivateRoute>} />
            <Route path="/cart" element={<PrivateRoute><CartPage /></PrivateRoute>} />
            <Route path="/orders" element={<PrivateRoute><Orders /></PrivateRoute>} />
            <Route path="/order-details" element={<PrivateRoute><OrdersDetails /></PrivateRoute>} /> */}
            <Route path="/franchise" element={<RoleRoute allowedRoles={['ROLE_SUPER_ADMIN']}><Franchise /></RoleRoute>} />
            <Route path="/add-franchise" element={<RoleRoute allowedRoles={['ROLE_SUPER_ADMIN']}><FranchiseModal /></RoleRoute>} />
            {/* <Route path="/payout" element={<Payout />} /> */}
            <Route path="/academy" element={<PrivateRoute><Academy /></PrivateRoute>} />

            <Route path="/help" element={<PrivateRoute><Help /></PrivateRoute>} />
            <Route path="/documentation" element={<PrivateRoute><Documentation /></PrivateRoute>} />
            <Route path="/faq" element={<PrivateRoute><Faq /></PrivateRoute>} />
            <Route path="/trustSafety" element={<PrivateRoute><TrustSafety /></PrivateRoute>} />
        </Routes>
    );
};

export default AppRouter;
